// import React from 'react'

// const CreateCharge = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default CreateCharge

// import React from 'react'

// const Createchargetype = () => {





import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs, IconButton,
  Link, Tooltip, Divider, List, ListItem, ListItemText, ListItemSecondaryAction
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { SETTING_API_04, SETTING_API_07, SETTING_API_19, SUPPLIER_API_11 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { externalpostApi } from "../../services/externalApis";
import { useLocation } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
function CreateCharge() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const {   LOCCODE,STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";
  const [items, setItems] = useState([]);
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    chargetype: "",
    
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
       
        chargetype: selectedItem.chargetype,
     
    chargecode: selectedItem.chargecode,
      });
    }
  }, [selectedItem]);
  
  const handleCancel = () => {
    setSelectedItemDetails({
      chargetype: "",
      chargecode: "",
    });

  };



 console.log("Selected Item Details:", selectedItemDetails);

  useEffect(() => {
    setPageData({
      title: " Charges",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const goBackToView = () => {
    navigate("/vcharges");
  };

const handleInputChange = (e) => {
  const { name, value } = e.target;
  
  // Remove all leading spaces
  const cleanedValue = typeof value === "string" ? value.replace(/^\s+/, "") : value;
  const trimmedValue = typeof cleanedValue === "string" ? cleanedValue.trim() : cleanedValue;

  // Validate max length
  if (typeof cleanedValue === "string" && cleanedValue.length > 30) {
    setError((prevError) => ({
      ...prevError,
      [name]: "Input cannot exceed 30 characters.",
    }));
    return;
  }

  // Validate empty string
  if (typeof cleanedValue === "string" && trimmedValue === "") {
    setError((prevError) => ({
      ...prevError,
      [name]: "Input cannot be empty or just spaces.",
    }));
  } else {
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  }

  // Always update the value
  setSelectedItemDetails((prevDetails) => ({
    ...prevDetails,
    [name]: cleanedValue,
  }));
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_19, "get", {
          COMPCODE,
            LOCCODE:STAFFMAPLOCODE,


          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

    useEffect(() => {
      const fetchData = async () => {
        setIsLoading(true);
        try {
          // const result = await externalgetApi(
          //   `${SETTING_API_19}`,
          //   "get",
          //   { 
          //     STS: CON_STATUS_ACTIVE }
          // );
  
           const result = await externalgetApi(SETTING_API_19, "get", {
                            COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
                    STS: CON_STATUS_ACTIVE,
                  });

          setItems(result);
          console.log("result.....", result);
        } catch (err) {
          setError(err);
          console.error("Fetch error:", err);
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchData();
    }, []);

  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { chargetype } = selectedItemDetails;

    const requiredFields = [
      { name: "chargetype", value: chargetype, label: "Charge Type" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

  if (data) {
  const isDuplicate = data.some((item) => {
    const itemChargeType = item?.chargetype?.toLowerCase?.() || "";
    const selectedChargeType = chargetype?.toLowerCase?.() || "";

    return (
      item.chargecode !== selectedItemDetails?.chargecode &&
      itemChargeType === selectedChargeType
    );
  });

  if (isDuplicate) {
    setAlertMessage("Charge Type Already Exists.");
    setAlertType("warning");
    setAlertOpen(true);
    return;
  }
}


    const BRAND_CODE = selectedItem ? (selectedItem.chargecode) : 0;
    console.log("Brand Code:", BRAND_CODE);

    const staticValues = {
      COMPCODE,
        LOCCODE:STAFFMAPLOCODE,


      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      chargecode: BRAND_CODE,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi( SETTING_API_19, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Created Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
      setSelectedItemDetails({
        chargetype: "",
      });
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
   
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to Charge Types" arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Settings
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
       {isEdit ? "Edit  Charge Type" : "Create Charge Type "}
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 8, sm: 10, md: 10, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}> {isEdit ? "Edit  Charge Type" : " Create Charge Type "}</Typography>
            </Grid>
          </Grid>
        </AppBar>
       
              <Box
                 component="form"
                 noValidate
                 autoComplete="off"
                 sx={styles.add_form_page_container}
               >
                 <Grid
                   container
                   spacing={2}
                   sx={styles.add_form_page_grid_container}
                   alignItems="stretch"
                 >
                   {/* Left Section */}
                   <Grid
                     item
                     size={{ xs: 12, sm: 6, md: 5, lg: 5, xl: 5 }}
                     sx={{ display: "flex", flexDirection: "column" }}
                   >
                     <Typography sx={styles.appbar_title}>
                       Charge List
                     </Typography>
                     <List
                       dense
                       sx={{ p: 0, mt: 2, maxHeight: 400, overflow: "auto" }}
                     >
                       {items.map((item) => (
                         <ListItem
                           key={item.id}
                           sx={{
                             borderRadius: 2,
                             boxShadow: "0px 1px 5px rgba(0,0,0,0.1)",
                             mb: 1,
                             bgcolor: "#fff",
                             "&:hover": {
                               bgcolor: "#f5f5f5",
                             },
                             px: 2,
                             py: 1.5,
                           }}
                         >
                           <ListItemText
                             primary={item.chargetype}
                             primaryTypographyProps={{
                               fontSize: "14px",
                               fontWeight: 500,
                               color: "#333",
                             }}
                           />
                           <ListItemSecondaryAction>
                             <Button
                               variant="contained"
                               color="primary"
                               size="small"
                               startIcon={<AddCircleOutlineIcon />}
                               sx={{
                                 bgcolor: "#1976d2",
                                 "&:hover": { bgcolor: "#115293" },
                                 textTransform: "none",
                               }}
                              onClick={() => {
  setSelectedItemDetails((prevDetails) => ({
    ...prevDetails,
    chargetype: item.chargetype,
  }));
  setError((prevError) => ({
    ...prevError,
    chargetype: "",
  }));
}}
                             >
                               Add
                             </Button>
                           </ListItemSecondaryAction>
                         </ListItem>
                       ))}
                     </List>
                   </Grid>
       
                   {/* Vertical Divider */}
                   <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
       
                   {/* Right Section */}
       
                   <Grid
                     item
                     size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                     sx={{ display: "flex", flexDirection: "column" }}
                   >
                     {/* <TextField
                       id="description"
                       label=" Document  Category"
                       variant="outlined"
                       fullWidth
                       required
                       size="small"
                       name="doccatname"
                       value={selectedDoccatname}
                       disabled
                       // onChange={handleInputChange}
                       // error={!!error.descrip}
                       sx={{ mt: 2 }} // <-- Added margin top
                       // helperText={error.descrip}
                       FormHelperTextProps={{
                         sx: { fontSize: "12px", color: "red" },
                       }}
                     /> */}
       

        <TextField
                id="brand-name"
                label=" Charge Type"
                variant="outlined"
                fullWidth
                size="small"
                required
                   name="chargetype"
                value={selectedItemDetails.chargetype}
                onChange={handleInputChange}
                error={!!error.chargetype}
                helperText={error.chargetype}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
                   </Grid>
                 </Grid>
               </Box>
       
                <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
            onClick={handleCancel}
      
          >
              Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
            onClick={handleConfirmClick}
       
          >
           {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Box>

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
    </>
  );
}

export default CreateCharge;
